import { useMemo, useRef } from 'react';

/**
 * Keep the commercial teacher model name available for Compare dropdown options
 * even when the active comparison target is another SpecificAI version (the API
 * omits evaluated_teacher_model_name in that mode).
 */
export function useStableTeacherNameForCompare({
  evaluatedTeacherModelName,
  teacherModelProcessing,
  usecaseTeacherModel,
}) {
  const stableRef = useRef(null);

  return useMemo(() => {
    if (evaluatedTeacherModelName) {
      stableRef.current = evaluatedTeacherModelName;
      return evaluatedTeacherModelName;
    }
    if (teacherModelProcessing && usecaseTeacherModel) {
      stableRef.current = usecaseTeacherModel;
      return usecaseTeacherModel;
    }
    return stableRef.current;
  }, [evaluatedTeacherModelName, teacherModelProcessing, usecaseTeacherModel]);
}
